"use client"

import { useEffect } from "react"

export function useClickOutside(refs, handleOnClickOutside) {
  useEffect(() => {
    const refArray = Array.isArray(refs) ? refs : [refs]

    function listener(event) {
      const clickedInside = refArray.some(ref => {
        const el = ref?.current
        return el && (el === event.target || el.contains(event.target))
      })

      if (clickedInside) return

      handleOnClickOutside(event)
    }

    document.addEventListener("mousedown", listener, true)
    document.addEventListener("touchstart", listener, true)

    return () => {
      document.removeEventListener("mousedown", listener, true)
      document.removeEventListener("touchstart", listener, true)
    }
  }, [refs, handleOnClickOutside])
}